import styled from 'styled-components';

export const RemovePropertyMortgageeContainer = styled.div.attrs({
  id: 'removePropertyMortgageeContainer',
})`
  margin-top: 30px;
  width: 100%;
`;
export const RemovePropertyMortgageeFieldHeader = styled.h4.attrs({
  id: 'removePropertyMortgageeFieldHeader',
})`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 0.9rem;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeSpeed;
  margin-bottom: 8px;
  width: 100%;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const RequiredField = styled.span.attrs({})`
  color: red;
`;
export const RemovePropertyMortgageeField = styled.form.attrs({})`
  min-width: 200px;
`;
export const RemoveMortgageeTextAreaField = styled.textarea.attrs({
  id: 'removeMortgageeTextAreaField',
})`
  height: 100px;
  margin-top: 5px;
  margin-bottom: 10px;
  width: 100%;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const RemoveMortgageePropertyComponent = styled.div.attrs({})`
  margin-bottom: 12px;
`;
export const RemoveMortgageeRadioButton = styled.input.attrs((props) => ({
  id: props.id,
  type: 'radio',
}))`
  display: inline-block;
  vertical-align: top;
  margin-top: 5px;
`;
export const RemoveMortgageeButtonsContainer = styled.div.attrs({})`
  text-align: right;
  margin-right: 2%;
  margin-top: 10%;
  @media (max-width: 384px) {
    text-align: center;
  }
`;
export const RemoveMortgageeButton = styled.button.attrs({})`
  margin-left: 10px;
  padding: 10px 20px;
  background-color: ${(props) => props.theme.primaryColor};
  color: white;
  :disabled {
    background-color: gray;
  }
  @media (max-width: 384px) {
    margin-bottom: 10px;
  }
`;

export const RemoveMortgageeCancelButton = styled(RemoveMortgageeButton).attrs({ id: 'Cancel' })``;
export const RemoveMortgageeSubmitButton = styled(RemoveMortgageeButton).attrs({ id: 'Submit' })``;

export const RadioAddressLabel = styled.label.attrs((props) => ({
  id: props.id + ' Label',
}))`
  display: inline-block;
  margin-left: 8px;
`;
